//Authentications End points
export const API_BASE_URL = process.env.REACT_APP_BASE_URL;
export const FRONT_END_URL = process.env.REACT_APP_URL;
export const LOGIN_END_POINT = '/sign-in';
export const REGISTER_ACCOUNT_END_POINT = '/register-account';
export const FORGOT_PASSWORD_VERIFICATION_END_POINT = '/forgot-pass-verification/';
export const GET_DEPARTMENT_END_POINT = '/get-departments';
export const GET_EMPLOYEE_END_POINT = '/get-employees';
export const UPDATE_PASSWORD_END_POINT = '/update-password';
export const RESEND_SIGNUP_EMAIL_END_POINT = '/resend-signup-link/';
export const ARCHIVE_USER_END_POINT = '/archive-user/';
export const GET_USER_DETAILS_END_POINT = '/get-user-details/';
export const UPDATE_USER_ACCOUNT_END_POINT = '/update-user-account';
export const GET_PRIV_END_POINT = '/get-privilege/';
export const UPDATE_PRIV_END_POINT = '/update-priv/';
export const GET_ARCHIVED_USERS_END_POINT = '/get-archived-users';
export const RECOVER_USERS_END_POINT = '/recover-user/';
export const UPDATE_DEPARTMENT_NAME_END_POINT = '/update-department-name/';
export const ADD_DEPARTMENT_END_POINT = '/add-department';
export const DELETE_DEPARTMENT_END_POINT = '/delete-department/';
export const GET_USERS_BY_DEPARTMENT_END_POINT = '/get-users-by-department/';

//analytics / Dashboard
export const GET_USERS_ANALYTICS_END_POINT = '/user-analytics';
export const GET_DEPARTMENT_ANALYTICS_END_POINT = '/department-analytics';
export const GET_EMPLOYEES_ON_LEAVE_TODAY = '/analytics/employees-on-leave-today';

//JDL Endpoints
export const ADD_CLIENT_END_POINT = '/add-client';
export const GET_CLIENTS_END_POINT = '/get-all-clients';
export const FIND_CLIENTS_END_POINT = '/find-clients/';
export const FIND_DOMAIN_END_POINT = '/find-domain/';
export const FIND_SEGMENT_END_POINT = '/find-segments/';
export const FIND_SUB_SEGMENT_END_POINT = '/find-sub-segments/';
export const SAVE_JDL_END_POINT = '/save-jdl';
export const GET_JDL_MONTH_YEAR_END_POINT = '/get-jdl-by-year-month/';
export const GET_JDL_BY_ID_END_POINT = '/get-jdl-by-id/';
export const GET_JDL_STATUS_END_POINT = '/get-jdl-status';
export const UPDATE_JDL_END_POINT = '/update-jdl/';
export const SET_JDL_PUBLISH_STAT_END_POINT = '/set-jdl-publish-stat';
export const GET_ARCHIVE_JDL_END_POINT = '/get-archive-jdl';
export const DELETE_JDL_END_POINT = '/permanent-delete-jdl/';
export const GET_ALL_DOMAINS_END_POINT = '/get-domains';
export const GET_CLIENT_BY_ID_END_POINT = '/get-client-by-id/';
export const UPDATE_CLIENT_NAME_END_POINT = '/update-client-name/';
export const DELETE_CLIENT_END_POINT = '/delete-client/';
export const GET_SEGMENT_BY_DOMAIN_END_POINT = '/get-segments-by-domain/';
export const ADD_NEW_SEGMMENT_END_POINT = '/add-new-segment';
export const GET_SUB_SEGMENTS_END_POINT  = '/get-sub-segments-by-segment-id/';
export const ADD_NEW_SUB_SEGMENT_END_POINT = '/add-new-sub-segment';
export const ADD_NEW_DOMAIN_END_POINT = '/add-new-domain';
export const UPDATE_DOMAIN_END_POINT = '/update-domain/';
export const DELETE_DOMAIN_END_POINT = '/delete-domain/';
export const DELETE_SEGMENT_END_POINT = '/delete-segment/';
export const UPDATE_SEGMENT_NAME_END_POINT = '/update-segment-name/';
export const UPDATE_SUB_SEGMENT_NAME_END_POINT = '/update-sub_segment-name/';
export const DELETE_SUB_SEGMENT_END_POINT = '/delete-sub_segment/';
export const SEARCH_ROLES_END_POINT = '/search_roles';
export const GET_JDL_TBL_END_POINT = '/get-jdl-tbl-by-id/';

//Updated Manage JDL End point
export const RETRIEVE_REQUIREMENTS_BY_ID_END_POINT = '/get-requirements-by-id/';

//requirements end point
export const MONTHLY_ROLE_REQUIREMENTS = '/get-monthly-requiremenst/';
export const SEARCH_REQUIREMENTS = '/search-requirements';
export const DOWNLOAD_CSV_REQUIREMENTS = '/download-requirements-csv';
export const UPLOAD_CSV_END_POINT = '/upload-req-csv';
export const SOFT_DELETE_END_POINT = '/soft-delete-requirements';
export const GET_ARCHIVE_ROLE_END_POINT = '/get-archive-roles';

//Job finder enpoint
export const CV_JOB_FINDER_END_POINT = '/job-finder/upload-cv';

//connect to spreadsheet jdl end point
export const CONNECT_SPREAD_SHEET_END_POINT = '/connect-spread-sheet';
export const RETRIEVE_SHEET_JDL = '/retrieve-spread-sheet-jdl/'

//import roles from spreadsheet to database
export const IMPORT_ROLES_DB_END_POINT = '/import-roles';

//Attendance end point
export const SET_ATTENDANCE_END_POINT = '/set-attendance/';
export const GET_ATTENDANCE_DATA_TODAY_END_POINT = '/get-attendance-today/';
export const GET_MONTHLY_ATTENDANCE_RECORD_END_POINT = '/user-monthly-attendance-record/';

//Leave Credits Tracker End points
export const GET_LEAVE_CREDITS_END_POINT = '/leave-cred/get-leave-credits';
export const UPDATE_VL_CRED_BY_ID = '/leave-cred/update-vl-cred-by-id';
export const UPDATE_SL_CRED_BY_ID = '/leave-cred/update-sl-cred-by-id';
export const GET_USER_LEAVE_CRED_DATA = '/leave-cred/get-user-leave-credits/';

//Leave Process
export const GET_LEAVE_APPROVERS = '/leave-process/process-leave-approver';
export const SUBMIT_LEAVE = '/leave-process/submit-leave';
export const GET_LEAVE_REQUEST = '/leave-process/get-leave-request/';
export const UPDATE_LEAVE_REQUEST_STATUS = '/leave-process/update-leave-request/';
export const GET_LEAVE_REQUEST_DATA_BY_ID = '/leave-process/get-leave-req-data/';

//DTR report extraction
export const EXTRACT_DTR_REPORT = '/report-extraction/dtr-report-extraction';
export const GET_DTR_FILES = '/report-extraction/get-dtr-files';
export const DOWNLOAD_DTR_FILE = '/report-extraction/download-dtr-file'; 
export const DELETE_DTR_FILE = '/report-extraction/delete-dtr-file/';

//Leave Report
export const DOWNLOAD_LEAVE_REPORT = '/leave-report/extract-data';

//HR Management
export const GET_EMPLOYEE_DATA = '/hr-management/get-employees-data/';
export const UPDATE_EMPLOYEE_TIME_SCHEDULE = '/hr-management/update-time-sched/';
export const UPDATE_EMPLOYEE_TIME_SCHEDULE_ONSITE = '/hr-management/update-time-sched-onsite/';
export const UPDATE_EMPLOYEE_DATA = '/hr-management/update-employee-data';
export const GET_FULL_EMPLOYEE_DATA = '/hr-management/get-full-employee-data/';

//CV Formatter end point
export const OCR_PROCESS_END_POINT = '/cvf/ocr-process';
export const EXTRACT_TEXT_FROM_CV = '/cvf/extract-text';
export const AI_PROCESS_CVF = '/cvf/ai-process/ai-response';
export const FORMAT_CV_RAW_TEXT_END_POINT = '/formart-cv-raw-text';
export const DOWNLOAD_CV_PDF_END_POINT = '/download-cv-pdf';
export const DOWNLOAD_CV_DOCX_END_POINT = '/download-cv-docx';

//CST Dashboard end point
export const PROCESS_CLIENT_REVENUE_END_POINT = '/cst-dashboard/process-client-rev';
export const PROCESS_UPDATE_CLIENT_MONTHLY_REV = '/cst-dashboard/process/update-client-rev/';
export const GET_REVENUE_SUMMARY = '/cst-dashboard/revenue-summary/';

//Pipeline end point
export const PIPELINE_ROLES_BY_CLIENT = '/pipeline/roles-by-client/';
export const PIPELINE_ADD_CDD_IN_THE_PIPE = '/pipeline/add-cdd/';
export const PIPE_LINE_GET_CDD_PIPELINE = '/pipeline/get-cdd-pipeline/';
export const PIPE_LINE_UPDATE_CDD_PIPELINE = '/pipeline/update-cdd-pipeline';
export const PIPE_LINE_GET_RECRUITERS_LIST = '/pipeline/recruiters-list';
export const PIPELINE_DELETE_CDD = '/pipeline/delete-cdd/'

//Recruiters Target Revenue
export const RECRUITERS_REVENUE_UPDATE_TARGET = '/recruiters-revenue/update-target/';
export const RECRUITERS_REVENUE_CURRENT_TARGET = '/recruiters-revenue/current-target/';
export const RECRUITERS_REVENUE_TRACKER_SUMMARY = '/recruiters-revenue/revenue-summary/';

//CDD Profile
export const PROCESS_CDD_PROFILE = '/data-entry/cv-upload-process';
export const GET_CDD_PROFILE = '/data-entry/get-candidates-info';